module.exports = __webpack_public_path__ + "img/rmcs_2.40618047.jpg";